import React, { useState, useRef, useEffect } from "react";
import { InstrumentName } from "../types/sound";
import { getInstrumentLabel } from "../utils/instrumentLabels";
import styles from "../styles/InstrumentSelector.module.css";

interface InstrumentSelectorProps {
    value: InstrumentName;
    onChange: (instrument: InstrumentName) => void;
    availableInstruments: InstrumentName[];
}

export default function InstrumentSelector({
    value,
    onChange,
    availableInstruments,
}: InstrumentSelectorProps) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (instrument: InstrumentName) => {
        onChange(instrument);
        setIsOpen(false);
    };

    return (
        <div className={styles.instrumentSelectorWrapper} ref={dropdownRef}>
            <label className={styles.instrumentLabel}>Instrument:</label>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`${styles.instrumentButton} ${isOpen ? styles.instrumentButtonOpen : ""}`}
            >
                {getInstrumentLabel(value)}
                <span className={styles.instrumentChevron}>▼</span>
            </button>

            {isOpen && (
                <div className={styles.instrumentDropdown}>
                    {availableInstruments.map((instrument) => (
                        <button
                            key={instrument}
                            onClick={() => handleSelect(instrument)}
                            className={
                                instrument === value
                                    ? `${styles.instrumentOption} ${styles.instrumentOptionActive}`
                                    : styles.instrumentOption
                            }
                        >
                            {getInstrumentLabel(instrument)}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
